import { render } from "./B2CHeaderBG.vue?vue&type=template&id=873b9ffc&scoped=true&lang=pug"
const script = {}

import "./B2CHeaderBG.vue?vue&type=style&index=0&id=873b9ffc&scoped=true&lang=sass"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-873b9ffc"]])

export default __exports__